import { useRef, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "reactstrap";

//Unform e componentes
import { Form } from "@unform/web";
import UInput from "@/frontend/componentes/unform/UInput";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { SISTEMA_SIGLA } from "@/common/constantes";
import { PAGINACAO } from "@/common/utils/paginacao";
import { fn_validarCampoEspacoBranco } from "@/common/utils/util";

//Util
import { ICONES_ACESSO } from "@/frontend/utils/icones.jsx";
import { fn_validarCamposObrigatorios } from "@/frontend/utils/form";
import { fn_getImagemLogoTenant } from "@/frontend/utils/file";
import {
  MENSAGENS_ERRO,
  showMensagemErro,
  showMensagemErroApi,
} from "@/frontend/utils/mensagens";
import { fn_aplicarTema, fn_getTemaTenant } from "@/frontend/utils/tema";
//import { useEnterAsTab } from "@/frontend/utils/useEnterAsTab";

//API
import { api_login } from "@/frontend/services/api/api_others";

function TLogin({ tenant }) {
  //, path }) {

  const { signIn } = useAuth();

  const navigate = useNavigate();

  //### USE REF ###
  const formRef = useRef(null);
  // const domRef = useRef(null); // ref do wrapper DOM
  // useEnterAsTab(formRef, domRef);

  const [imageSrc, setImageSrc] = useState(null);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    document.body.classList.add("login");

    function isMobileDevice() {
      const isMobile = /iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );

      const isAndroidMobile =
        /Android/i.test(navigator.userAgent) &&
        /Mobile/i.test(navigator.userAgent);

      return isMobile || isAndroidMobile;
    }

    let timer = null;

    if (isMobileDevice()) {
      navigate("/incompativel");
    } else {
      //signOut();

      //Aplica o tema do tenant
      fn_aplicarTema(fn_getTemaTenant(tenant?.path));

      timer = setTimeout(() => {
        // Foco no primeiro campo
        formRef?.current?.getFieldRef("identificacao")?.current?.focus();
      }, 100);
    }

    return () => {
      document.body.classList.remove("login");

      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  //Ao receber o tenant
  useEffect(() => {
    async function checkImage() {
      if (tenant) {
        setImageSrc(await fn_getImagemLogoTenant({ tenant }));
      }
    }
    checkImage();
  }, [tenant]);

  //### FUNÇÕES ###
  function getDadosSessaoUsuario(identificacao, ret) {
    const perfil = ret.usuario.perfil;

    const response = {
      sessaoUsuario: {
        token: ret.token,
        tempo_sessao: ret.tempo_sessao,

        path: tenant?.path,

        usuario: {
          id: ret.usuario.id,
          id_tenant: ret.usuario?.id_tenant,
          identificacao: identificacao,
          nome: ret.usuario.nome,
          perfil: perfil, //{ id: perfil.id, nome: perfil.nome },
          data_ultimo_login: ret.usuario.data_ultimo_login,
        },

        menus: ret.acesso.menus,
        telas: ret.acesso.telas,
        areas: ret.acesso.areas,

        //Posição do menu (topo ou lateral) da parametrização global
        posicao_menu: ret.params?.posicao_menu,
      },
    };

    return response;
  }

  /*
   * Seta a parametrização de paginação default no escopo global do sistema
   */
  function setParametrizacoes(params) {
    //Inicializa a parametrização da paginação default no login para não precisar buscar a cada consulta
    if (params?.paginacao) {
      PAGINACAO.ITENS_POR_PAGINA_DEFAULT = params.paginacao;
    }
  }

  //Valida os dados do formulário
  function validarFormulario(body) {
    let isValido = fn_validarCamposObrigatorios(formRef, body);

    if (isValido) {
      if (!fn_validarCampoEspacoBranco(body.identificacao)) {
        showMensagemErro(MENSAGENS_ERRO.ESPACO_BRANCO, "identificação");
        isValido = false;
      }
    }

    return isValido;
  }

  //### EVENTOS ###
  //SUBMIT - Botão Entrar
  async function handleSubmit(body) {
    try {
      if (validarFormulario(body)) {
        const ret = await api_login(
          body.identificacao,
          body.senha,
          tenant?.path,
        );

        if (ret?.usuario) {
          setParametrizacoes(ret?.params);

          //Loga o usuário no sistema
          const response = getDadosSessaoUsuario(body.identificacao, ret);

          signIn(response);
          navigate("/dashboard");
        }
      }
    } catch (error) {
      showMensagemErroApi(error, "logar");
    }
  }

  return (
    <div className="container-fluid vh-100 overflow-hidden">
      <div className="row h-100">
        {/* Lado esquerdo */}
        <div className="col-8 d-flex flex-column justify-content-center align-items-center p-0">
          {/* <img src="/login.jpg" className="img-login" /> */}
          <img src="/login.jpg" className="img-login-cheia" />
          {/* <div className="img-login-fundo">
            <img src="/login.jpg" className="img-login-menor" />
          </div> */}
        </div>

        {/* Lado direito - LOGIN */}
        <div className="col-4 d-flex justify-content-center align-items-center bg-white">
          <Form ref={formRef} onSubmit={handleSubmit} className="w-75">
            <div className="sistema-sigla">{SISTEMA_SIGLA}</div>

            <div className="text-center mb-4 h5">{tenant?.nome}</div>

            <div className="imagem-tenant-login text-center mt-4">
              {imageSrc ? (
                <img src={imageSrc} />
              ) : (
                <img src="/logo-default.jpg" />
              )}
            </div>

            <div>
              <UInput
                name="identificacao"
                label="Identificação*"
                lowerCase={true}
                maxLength={100}
                icone={ICONES_ACESSO.USUARIO}
              />

              <UInput
                type="password"
                name="senha"
                label="Senha*"
                caseSensitive={true}
                maxLength={20}
                icone={ICONES_ACESSO.SENHA}
              />

              <Button
                type="submit"
                name="btnLogin"
                color="primary"
                className="w-100 mt-3"
              >
                Login
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default TLogin;
